import Collapse from "../../../layout/Collapse";
import TextInput from "../../../form/TextInput";
import React, {Fragment} from "react";
import Button from "../../../form/Button";
import ComponentLoader from "../../../form/ComponentLoader";
import StoreOrderForm from "../../forms/storeorderForm";
import {stateTypes, orderTypes} from "../../storeorder/storeorderEditor";
import ComponentConfig from "../../../form/ComponentConfig";
import classNames from "classnames";

class StoreOrderLoaded extends React.Component {
    state = {
        opened: false
    }
    render() {
        return (
            <div className="row form-row">
                <div className="col-sm-12">
                    <label className="control-label">Raktári rendelés</label>
                    <Button block={true} color={this.state.opened ? "primary" : "default"} onClick={() => this.setState({opened: !this.state.opened})}>
                        Raktári rendelés adatai <span className="caret"/>
                    </Button>
                    <Collapse collapsed={this.state.opened}>
                        <div>
                            <StoreOrderForm stateTypes={stateTypes} orderTypes={orderTypes} values={this.props.values} componentConfig={this.props.componentConfig} getFieldProps={() => {
                                return {disabled: true};
                            }}/>
                        </div>
                    </Collapse>
                </div>
            </div>
        );
    }
}

const StoreOrder = (props) => <ComponentConfig componentName="storeorder"><ComponentLoader componentName="storeorder" componentId={props.id} view="admin"><StoreOrderLoaded /></ComponentLoader></ComponentConfig>;

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems} = props;
    let Tag = propsTop.tag || Collapse;
    return <div className="row form-row">
        <div className="col-md-12" style={{marginTop: "5px"}}>
            <Tag {...(Tag === Fragment ? {} : {button: <Button tag="a" color="default" className="pull-right" icon={{lib: "fa", name: "paperclip"}}>Egyéb</Button>})}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <TextInput name={props.componentConfig.idfield} value={props.values[props.componentConfig.idfield]} label="Kód" role="idfield"/>
                    </div>
                    <div className="col-sm-8 col-sm-pull-4">
                        <TextInput name="label" label="Cimke" {...props.getProps("label")} value={props.getValue("label")} saveChanges={props.setFieldValue}/>
                    </div>
                </div>
                {props.values?.xtradata?.storeorder && <StoreOrder id={props.values.xtradata.storeorder} />}
                {props.values.message && props.values.message_type && <div className={classNames("operationlist-message callout", {
                    ["callout-" + ((type) => {
                        switch (type) {
                            case "warning":
                                return "warning";
                            case "notification":
                            case "info":
                                return "info";
                            case "success":
                                return "success";
                            case "danger":
                            case "error":
                                return "danger";
                            default:
                                return "secondary";
                        }
                    })(props.values.message_type)]: true
                })}>
                    {props.values.message.split(/\\n/).map((item, index) => (index === 0) ? item : [<br key={index} />, item.split(/\\t/).map((item, index) => index === 0 ? item : [<span className="tab"/>, item])])}
                </div>}
            </Tag>
        </div>
    </div>;
}